module.exports = __webpack_public_path__ + "static/jquery-472594d6f9a337de026010f05cdc4ccf.svg";